import { cn } from "@/lib/utils";

interface LogoProps {
  variant?: "icon-wordmark" | "icon" | "wordmark";
  className?: string;
  /** Set true when the logo sits on a dark/coloured background (e.g. footer) */
  inverted?: boolean;
  /** Show ™ superscript near the A */
  trademark?: boolean;
}

export function Logo({
  className,
  inverted = false,
  trademark = false,
}: LogoProps) {
  // Z bolt: always purple (hardcoded in SVG, no filter needed)
  // UPA™: fill="currentColor" → inherits SVG's text colour → proper transparent letter holes
  // Colour: dark on light bg, white on dark bg (via inverted prop or dark: class)
  return (
    <svg
      viewBox="0 0 120 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(
        "w-auto",
        inverted ? "text-white" : "text-[#1a1a1a] dark:text-white",
        className
      )}
      aria-label="Zupa"
    >
      {/* Z lightning bolt — loaded from SVG, stays purple on any background */}
      {/* y=8 aligns to Barlow Bold cap-top; height=28 matches cap-height at fontSize=40 */}
      <image
        href="/zupa-z-bolt.svg"
        x={0}
        y={8}
        width={22}
        height={28}
        preserveAspectRatio="xMidYMid meet"
      />

      {/* UPA text — currentColor gives native transparent P/A counter holes */}
      <text
        x="26"
        y="36"
        fontFamily="'Barlow', 'Futura', 'Century Gothic', 'Trebuchet MS', sans-serif"
        fontWeight="700"
        fontSize="40"
        letterSpacing="3"
        fill="currentColor"
      >
        UPA
      </text>

      {/* ™ mark */}
      {trademark && (
        <text
          x="99"
          y="16"
          fontFamily="'Barlow', 'Futura', 'Century Gothic', 'Trebuchet MS', sans-serif"
          fontWeight="400"
          fontSize="18"
          fill="currentColor"
          opacity="0.75"
        >
          ™
        </text>
      )}
    </svg>
  );
}
